<template>
    <b-card no-body>
        <v-table    ref="table"
                    :fields="fields"
                    :items-provider="provider"
                    pagination="server"
                    :initial-load="false"
                    name="salary">
                        <template #additional-actions>
                            <div class="row align-items-center gy-50">
                                <div class="col-md-1 mb-1 mb-md-0">
                                    <select class="form-control bg-img-none" v-model="donem.month">
                                        <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                                    </select>
                                </div>
                                <div class="col-md-1 mb-1 mb-md-0">
                                    <select class="form-control bg-img-none" v-model="donem.year">
                                        <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                                    </select>
                                </div>
                                <div class="col-md-auto mb-1 mb-md-0">
                                    <select class="form-control bg-img-none" v-model="branchType">
                                        <option value="O">Org. Şube</option>
                                        <option value="S">SGK Şube</option>
                                    </select>
                                </div>
                                <div class="col-md-2 mb-1 mb-md-0" v-if="branchType == 'O'">
                                    <v-select-list append-to-body :options="branches" label="Name" v-model="branch" placeholder="Tüm Org. Şubeler"></v-select-list>
                                </div>
                                <div class="col-md-2 mb-1 mb-md-0" v-if="branchType == 'S'">
                                    <v-select-list append-to-body :options="sbranches" label="Name" v-model="sbranch" placeholder="Tüm SGK Şubeler"></v-select-list>
                                </div>
                                <div class="col-md-2 mb-1 mb-md-0">
                                    <v-select-list append-to-body :options="collarStatuses" label="Name" v-model="collarStatus" placeholder="Tüm Yakalar"></v-select-list>
                                </div>
                                <div class="col-md-2 mb-1 mb-md-0">
                                    <input placeholder="Ara..." class="form-control" v-model="search" v-on:keypress.enter="$refs.table.refresh()"/>
                                </div>
                                <div class="col-auto">
                                    <button class="btn btn-primary" v-on:click="$refs.table.refresh()">Sorgula</button>
                                </div>
                                <div class="col-auto">
                                    <v-executer :action="getExcel" variant="success" :loading="excelGetting">Excel</v-executer>
                                </div>
                            </div>
                        </template>
                    </v-table>
        
    </b-card>
</template>

<script>
import { BCard, } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import moment from 'moment'
import Additional from '@/utilities/additional'
import CompanyApi from '@/api/company'
import SystemDataApi from '@/api/system-data'

export default {
    components:{
        BCard
    },
    data(){
        return{
            fields:[
                {
                    name:'',
                    children:[
                        {name:'Adı Soyadı',key:'FullName',tdClass:'text-nowrap',sticky:true},
                        {name:'TCKN',key:'IdentityNumber',tdClass:'text-nowrap'},
                        {name:'IBAN',key:'IBAN',tdClass:'text-nowrap'},
                        {name:'SGK Şube',key:'SGKBranchName',tdClass:'text-nowrap'},
                        {name:'Sabit Maaşı',key:'GSalaryStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                        {name:'Giriş Tarihi',key:'SGKEntryDateStr',tdClass:'text-nowrap'},
                        {name:'Çıkış Tarihi',key:'SGKExitDateStr',tdClass:'text-nowrap'},
                        {name:'Yıllık İzin (Gün)',key:'YILLIK_IZINStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                        {name:'Kullanılan Ücretli İzin [Gün]',key:'UCRETLI_IZINStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                        {name:'Diğer Eksik Gün (Gün)',key:'DIGER_EKSIK_GUNStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                        {name:'Çalışma Maaşı',key:'CALISMA_KAZANCIStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                        {name:'Yıllık İzin',key:'YILLIK_IZIN_KAZANCStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                    ]
                },
                {
                    name:'Prim',
                    thClass:'bg-light-secondary',
                    children:[
                        {name:'Mesai',key:"MESAI_UCRETIStr",tdClass:'text-right text-nowrap border-left',thClass:'vt-th-text-right text-secondary'},
                        {name:'Yemek',key:"YEMEK_UCRETIStr",tdClass:'text-right text-nowrap',thClass:'vt-th-text-right text-secondary'},
                        {name:'Yol',key:"YOL_UCRETIStr",tdClass:'text-right text-nowrap',thClass:'vt-th-text-right text-secondary'},
                        {name:'Prim',key:"PRIMStr",tdClass:'text-right text-nowrap',thClass:'vt-th-text-right text-secondary'},
                        {name:'Destek',key:"DESTEK_PRIMIStr",tdClass:'text-right text-nowrap',thClass:'vt-th-text-right text-secondary'},
                        {name:'Hammaliye',key:"HAMMALIYE_BEDELIStr",tdClass:'text-right text-nowrap',thClass:'vt-th-text-right text-secondary'},
                        {name:'Yatma',key:"YATMAStr",tdClass:'text-right text-nowrap',thClass:'vt-th-text-right text-secondary'},
                        {name:'Yakıt Primi',key:"MAZOT_PRIMIStr",tdClass:'text-right text-nowrap',thClass:'vt-th-text-right text-secondary'},
                        {name:'Sıfırlama',key:"SIFIRLAMAStr",tdClass:'text-right text-nowrap',thClass:'vt-th-text-right text-secondary'},
                        {name:'Bayram Mesaisi',key:"BAYRAM_MESAISIStr",tdClass:'text-right text-nowrap',thClass:'vt-th-text-right text-secondary'},
                        {name:'Diğer',key:"DIGERStr",tdClass:'text-right text-nowrap',thClass:'vt-th-text-right text-secondary'},
                        {name:'Diğer Açıklama',key:"DIGERACIKLAMA",tdClass:'text-nowrap border-right',thClass:'vt-th-text-right text-secondary'},
                    ]
                },
                {
                    name:'',
                    children:[
                        {name:'Toplam Hakediş',key:'TOPLAM_HAKEDISStr',tdClass:'text-nowrap  text-right',thClass:'vt-th-text-right'},
                        {name:'Önceki Ay Toplam Tutar',key:'ONCEKI_AY_TOPLAM_HAKEDISStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                        {name:'Banka Ödeme',key:'BANKAYA_YATANStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                    ]
                },
                {
                    name:'Banka 1 Kesintiler',
                    thClass:'bg-light-info',
                    children:[
                        {name:'İcra',key:'ICRAStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                        {name:'Bes',key:'BESStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                        {name:'Avans',key:'AVANSStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                        {name:'Trafik Cezası ve Kesinti',key:'TRAFIK_CEZAveKESINTIStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                        {name:'Çek İle Ödenen',key:'CEK_ILE_ODENENStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                        
                    ]
                },
                {
                    name:'Banka 2 Kesintiler',
                    thClass:'bg-light-danger',
                    children:[
                        {name:'Avans',key:'BANKA_2_AVANSStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                        {name:'Trafik Cezası',key:'BANKA_2_TRAFIK_CEZASIStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                        {name:'Vukuat',key:'BANKA_2_VUKUATStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                    ]
                },
                {
                    name:'',
                    children:[
                        //{name:'Ticket Hariç Resmi Toplam',key:"TICKET_HARIC_RESMI_TOPLAMStr",tdClass:'text-nowrap  text-right',thClass:'vt-th-text-right'},
                        {name:"Yemek Kartı",component:true,tdClass:'text-right',componentOptions:{name:"g-salary-ticket/GSalaryTicket"}},
                        {name:'Yemek Kartı Üst Limit',key:"TICKETLIMITStr",tdClass:'text-nowrap  text-right',thClass:'vt-th-text-right'},
                        {name:'Banka 1',key:"TICKET_DAHIL_RESMI_TOPLAMStr",tdClass:'text-nowrap  text-right',thClass:'vt-th-text-right'},
                        {name:'Banka 2',key:"ELDEN_ODENECEKStr",tdClass:'text-nowrap  text-right',thClass:'vt-th-text-right'}
                        //{name:'Hatalar',key:'Errors',tdClass:'text-danger text-nowrap'}
                    ]
                }
            ],
            donem:{
                year:moment().year(),
                month:moment().month() + 1 
            },
            years:[],
            months:[
                {index:1,name:'Ocak'},
                {index:2,name:'Şubat'},
                {index:3,name:'Mart'},
                {index:4,name:'Nisan'},
                {index:5,name:'Mayıs'},
                {index:6,name:'Haziran'},
                {index:7,name:'Temmuz'},
                {index:8,name:'Ağustos'},
                {index:9,name:'Eylül'},
                {index:10,name:'Ekim'},
                {index:11,name:'Kasım'},
                {index:12,name:'Aralık'}
            ],
            branches:[],
            branch:null,
            sbranches:[],
            collarStatuses:[],
            branchType:'S',
            branch:null,
            sbranch:null,
            search:'',
            excelGetting:false,
            collarStatus:null,
        }
    },
    mounted(){
        this.configureYears()
        this.getBranches()
        this.getSBranches()
        this.getCollarStatuses()
        this.getBranches()
    },
    methods:{
        getExcel(){
            this.excelGetting = true
            EmployeeOperationsApi.SalaryTableExcel({
                PaginateRequest :{QueryParam:this.search},
                BranchId: this.branchType == 'O' ? (this.branch?.Id || null) : (this.sbranch?.Id || null),
                BranchTypeCode: this.branchType,
                CollarStatusId: this.collarStatus?.Id || null,
                Month: this.donem.month,
                Year: this.donem.year,
            }).then(res => {
                this.excelGetting = false
                if(res.data){
                    Additional.DownloadTab(res.data)
                }
            }).catch(err => {
                this.excelGetting = false
            })
        },  
        getBranches(){
            CompanyApi.Branch.ListByCode("O").then(res=>{
                this.branches = res.data.Data
            })
        },
        getSBranches(){
            CompanyApi.Branch.ListByCode("S").then(res=>{
                this.sbranches = res.data.Data
            })
        },
        getCollarStatuses(){
            SystemDataApi.CollarStatus().then(res => {
                this.collarStatuses = res.data.Data?.filter(s => s.Code != '-')
            })
        },
        configureYears(){  
            let years = []
            let year = moment().add(1,'year').format('YYYY')
            let firstYear = 1900
            while (firstYear <= year){
                years.push(firstYear++)
            }
            this.years = years.reverse()
        },
        provider(data){
            return EmployeeOperationsApi.SalaryTable({
                PaginateRequest :{...data,QueryParam:this.search},
                BranchId: this.branchType == 'O' ? (this.branch?.Id || null) : (this.sbranch?.Id || null),
                BranchTypeCode: this.branchType,
                CollarStatusId: this.collarStatus?.Id || null,
                Month: this.donem.month,
                Year: this.donem.year,
            })
        }
    },
}
</script>

<style>

</style>